
import axios from 'axios';
import urlpath from '../urlpath.js';

// Create axios instance
const api = axios.create({
  baseURL: urlpath,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add session ID
api.interceptors.request.use(
  (config) => {
    const sessionId = localStorage.getItem('hr_session_id');
    
    if (sessionId) {
      config.headers['X-Session-ID'] = sessionId;
    }
    
    return config;
  },
  (error) => {
    console.error('🔧 API request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('🔧 API Response Interceptor Error:');
    console.error('  Status:', error.response?.status);
    console.error('  URL:', error.config?.url);
    console.error('  Error data:', error.response?.data);
    
    if (error.response?.status === 401) {
      localStorage.removeItem('hr_session_id');
      localStorage.removeItem('hr_user');
      
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        alert('Session expired. Please login again.');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;